export default [
  ({ state, props, resolve }) => {
    const value = state.get(`selectr.${props.namespace}.input.value`)
    if (value === '') {
      // get the index of visible tags and the last index
      let focusedTag = state.get(`selectr.${props.namespace}.focusedTag`)
      let nextIndex = null
      const tags = state.get(`selectr.${props.namespace}.selected`)
      if (tags.length > 0) {
        if (focusedTag === null) {
          // focus the last tag
          nextIndex = tags.length - 1
        } else {
          if (focusedTag === 0) {
            return
          }
          nextIndex = focusedTag - 1
          state.set(
            `selectr.${props.namespace}.selected.${focusedTag}.focused`,
            false
          )
        }
        state.set(`selectr.${props.namespace}.focusedTag`, nextIndex)
        state.set(
          `selectr.${props.namespace}.selected.${nextIndex}.focused`,
          true
        )
        state.set(`selectr.${props.namespace}.performTagUnfocus`, true)
      }
    }
  }
]
